import { ControlType, DisplayFormat, Property, PropertyType } from "../../../base/types";

import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { formatValue } from "../../helpers";
import { useGetProperties } from "../../../base/hooks";

export const RepeaterColumn: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const value: string | undefined = properties[Property.Value];
    const tooltip: string | undefined = properties[Property.Tooltip];
    const displayFormat: DisplayFormat | undefined = properties[Property.Format];

    if (designerMode === DesignerMode.Draft) {
        return (
            <div style={{ display: "table-cell" }} className={className} title={tooltip}>
                <span>{formatValue(value, displayFormat)}</span>
                {children}
            </div>)
    } else {
        return (
            <td className={className} title={tooltip}>
                <span>{formatValue(value, displayFormat)}</span>
                {children}
            </td>)
    }
}

Registry.addControl({
    id: "ba57c34d-69f8-4e26-a520-3bbdeb1e75ec",
    name: "Repeater Column",
    type: ControlType.RepeaterColumn,
    properties: [
        { id: Property.Label, name: 'Heading', type: PropertyType.String },
        { id: Property.Value, name: 'Value', type: PropertyType.String },
        { id: Property.Format, name: 'Format', type: PropertyType.DisplayFormat },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: RepeaterColumn
})
